// extracted by mini-css-extract-plugin
export var video = "LocalToExternalVideoPlayer-module--video--10e34";
export var video__externalVideo = "LocalToExternalVideoPlayer-module--video__externalVideo--8f274";
export var video__fallbackImg = "LocalToExternalVideoPlayer-module--video__fallbackImg--0ca09";
export var video__invisible = "LocalToExternalVideoPlayer-module--video__invisible--c0818";
export var video__overlay = "LocalToExternalVideoPlayer-module--video__overlay--ef4a4";
export var video__playControl = "LocalToExternalVideoPlayer-module--video__playControl--6f5bd";
export var video__video = "LocalToExternalVideoPlayer-module--video__video--ea363";